import { Text, Typeahead } from "@merge-api/merge-javascript-shared";
import { LinkedAccount, LinkedAccountStatus } from "../../../../../../models/Entities";
import { filterLinkedAccountTypeaheadOptions } from "../../../../../shared/linked-account-typeahead/LinkedAccountTypeaheadFilter";
import LinkedAccountTypeaheadRenderOption from "../../../../../shared/linked-account-typeahead/LinkedAccountTypeaheadRenderOption";

interface LinkedAccountSelectorProps {
  isLoading: boolean;
  linkedAccounts: LinkedAccount[];
  selectedAccountId: string | undefined;
  onSelectAccount: (id: string | undefined) => void;
}

const LinkedAccountSelector = ({
  isLoading,
  linkedAccounts,
  selectedAccountId,
  onSelectAccount,
}: LinkedAccountSelectorProps) => {
  // Filter linked accounts based on status and merge org if needed
  const options = linkedAccounts.filter((acct) => {
    // Always filter by account status
    const hasCompleteStatus = acct.status === LinkedAccountStatus.COMPLETE;

    // filter out customer accounts
    const isMergeOrgAccount = acct.organization?.is_merge_org === true;
    return hasCompleteStatus && isMergeOrgAccount;
  });

  const selectedOption = options.find((acct) => acct.id === selectedAccountId) ?? undefined;

  return (
    <div>
      <Text variant="h6">Linked Account</Text>
      <Text as="div" className="text-gray-40 mb-2">
        The Linked Account you want to use to produce Common Models
      </Text>

      <Typeahead<LinkedAccount>
        loading={isLoading}
        placeholder="Select..."
        value={selectedOption}
        onChange={(_, option) => {
          if (option && !Array.isArray(option)) {
            onSelectAccount(option.id);
          } else {
            onSelectAccount(undefined);
          }
        }}
        getOptionLabel={(option) => option.end_user?.organization_name}
        renderOption={(option) => <LinkedAccountTypeaheadRenderOption option={option} />}
        filterOptions={(opts, state) => filterLinkedAccountTypeaheadOptions(opts, state)}
        options={options}
      />
    </div>
  );
};

export default LinkedAccountSelector;
